import {Sex} from '@/model/src/values/dv-6';
import {DomainValueReference} from '@/model/types';

export const mapClientGenderToDomainValue = (gender?: string | null): DomainValueReference | null => {
  switch (gender) {
    case 'M':
      return {$ref: Sex.MALE};
    case 'F':
      return {$ref: Sex.FEMALE};
    default:
      return null;
  }
};
